import React from 'react';

const Enroll = () => {
    return (
        <div style={{padding:'100px', backgroundColor:'pink'}} className='row'>
           <div  className='col-md-6'>
               <h3>How To Enroll Your  child to a class? </h3>
               Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequuntur possimus necessitatibus deleniti, aut hic omnis, vel blanditiis in vero recusandae enim facilis voluptates quisquam maiores, quasi cumque accusamus modi aliquam.
            </div> 
            <div className='col-md-4'>
                <button className='btn btn-outline-success justify-align-center '>Know More</button>
            </div>
        </div>
    );
};

export default Enroll;